import { $ as e, C as t, F as n, L as r, R as i, S as a, _ as o, at as s, g as c, h as l, i as u, m as d, ot as f, p, rt as m, t as h, v as g, w as _ } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as v } from "./normalize-props-DNjMoRjC.js";
import { i as y, n as b, r as x, t as S } from "./i18n-1IaTix1m.js";
import { t as C } from "./LLMMessage.ce-DuEsMir7.js";
//#region src/webcomponents/complete-phrase/locales/de-AT.json
var w = {}, T = {}, E = {}, D = {}, O = {}, k = { "complete-phrase": {
	title: "Probabilité du mot suivant",
	description: "Quand la barre est longue, le mot a une plus forte probabilité de convenir pour continuer cette phrase.",
	ariaLabelDescription: "Le mot {{name}} a une probabilité de {{percent}}%",
	clickHereButton: "Révéler le mot",
	successfullyCompletedSentence: "Cliquez sur le mot choisi par l’IA dans les propositions suivantes\xA0:",
	feedback: {
		sure: "En effet, c'est le mot le plus probable\xA0!",
		probably: "C’est possible ! L’IA peut aussi choisir le mot «\xA0{{word}}\xA0», qui est très probable...",
		notSure: "Pas sûr... L’IA choisira sans doute un mot plus probable\xA0: {{words, list(style: 'long'; type: 'disjunction';)}}."
	}
} }, A = {}, j = {}, M = { class: "probability-bar" }, N = { "aria-hidden": "true" }, P = { class: "sr-only" }, F = /*#__PURE__*/ h(/* @__PURE__ */ _({
	__name: "ProbabilityBar.ce",
	props: {
		name: { type: String },
		percent: { type: Number }
	},
	setup(e) {
		return (t, r) => (n(), g("div", M, [
			l("p", N, f(e.name), 1),
			l("p", P, f(t.$t("complete-phrase.ariaLabelDescription", {
				name: e.name,
				percent: e.percent
			})), 1),
			l("div", {
				style: s(`width: ${e.percent}%`),
				class: "probability-bar__percent",
				"aria-hidden": "true"
			}, null, 4),
			r[0] ||= l("div", {
				class: "probability-bar__background",
				"aria-hidden": "true"
			}, null, -1)
		]));
	}
}), [["styles", [".probability-bar[data-v-19f7d147]{padding-bottom:10px;font-family:Roboto,sans-serif;position:relative}.probability-bar p[data-v-19f7d147]{margin:0}.probability-bar__percent[data-v-19f7d147]{z-index:2;background-color:#122647;border-radius:5px;height:6px;position:absolute;left:0}.probability-bar__background[data-v-19f7d147]{z-index:1;background-color:#cdd1d9;border-radius:5px;width:100%;height:6px;position:absolute;left:0}.sr-only[data-v-19f7d147]{clip-path:inset(50%);white-space:nowrap;border:0;width:1px;height:1px;padding:0;position:absolute;overflow:hidden}"]], ["__scopeId", "data-v-19f7d147"]]), I = /*#__PURE__*/ h(/* @__PURE__ */ _({
	__name: "Button.ce",
	props: {
		label: { type: String },
		state: { type: String }
	},
	setup(e) {
		return (t, r) => (n(), g("button", { class: m(["complete-phrase_button", e.state]) }, [i(t.$slots, "icon"), a(" " + f(e.label), 1)], 2));
	}
}), [["styles", [".complete-phrase_button.primary{--background-color:#253858;--background-color-hover:#122647;--color:#fff;--color-hover:#fff}.complete-phrase_button.warning{--background-color:#ffcb33;--background-color-hover:#a16206;--color:#122647;--color-hover:#fff}.complete-phrase_button.primary,.complete-phrase_button.warning{background-color:var(--background-color);color:var(--color);cursor:pointer;white-space:nowrap;border:2px solid #0000;border-radius:8px;outline:none;justify-content:center;align-items:center;gap:8px;width:fit-content;margin:0 auto;padding:8px 24px;font-family:Roboto,sans-serif;font-size:1rem;font-weight:700;line-height:24px;transition:background-color .5s,color .5s;display:flex}:is(.complete-phrase_button.primary,.complete-phrase_button.warning)[aria-disabled=true]{cursor:not-allowed;opacity:.5}:is(.complete-phrase_button.primary,.complete-phrase_button.warning):not([aria-disabled=true]):hover{background-color:var(--background-color-hover);color:var(--color-hover);transition:background-color .5s,color .5s}:is(.complete-phrase_button.primary,.complete-phrase_button.warning):not([aria-disabled=true]):hover svg{color:var(--color-hover);transition:color .5s}"]]]), L = { class: "qcu" }, R = { class: "qcu__list" }, z = [
	"id",
	"aria-label",
	"checked",
	"disabled",
	"onClick"
], B = { for: "`choice${index}`" }, V = {
	key: 0,
	class: "feedback"
}, H = /*#__PURE__*/ h(/* @__PURE__ */ _({
	__name: "QCU.ce",
	props: {
		list: { type: Array },
		title: { type: String }
	},
	emits: ["answer"],
	setup(t, { emit: i }) {
		let a = i, s = e(null), { t: c } = x(), u = d(() => s.value.percent === 100 ? c("complete-phrase.feedback.sure") : s.value.percent >= 50 ? c("complete-phrase.feedback.probably", { word: t.list.find((e) => e.percent === 100).name }) : c("complete-phrase.feedback.notSure", { words: t.list.filter((e) => e.percent >= 50).map((e) => e.name) }));
		function m(e) {
			s.value = e, a("answer", e.name);
		}
		return (e, i) => (n(), g("div", L, [
			l("p", null, f(t.title), 1),
			l("section", R, [(n(!0), g(p, null, r(t.list, (e, t) => (n(), g("div", {
				key: t,
				class: "qcu__list-choice"
			}, [l("input", {
				id: `choice${t}`,
				type: "radio",
				name: "qcu-choice",
				"aria-label": e.name,
				checked: s.value === e,
				disabled: !!s.value,
				onClick: (t) => m(e)
			}, null, 8, z), l("label", B, f(e.name), 1)]))), 128))]),
			s.value ? (n(), g("section", V, f(u.value), 1)) : o("", !0)
		]));
	}
}), [["styles", ["[data-v-af3c8f6a]{color:#122647;font-family:Roboto,sans-serif}.qcu[data-v-af3c8f6a]{flex-direction:column;align-items:center;gap:16px;display:flex}.qcu p[data-v-af3c8f6a]{margin:0}.qcu__list[data-v-af3c8f6a]{gap:16px;display:flex}.qcu__list-choice[data-v-af3c8f6a]{position:relative}.qcu__list-choice input[data-v-af3c8f6a]{appearance:none;outline:none;width:100%;height:100%;position:absolute}.qcu__list-choice input:checked+label[data-v-af3c8f6a]{color:#fff;background-color:#3b82f6}.qcu__list-choice input[data-v-af3c8f6a]:hover{cursor:pointer}.qcu__list-choice input:hover+label[data-v-af3c8f6a]{color:#fff;background-color:#3b82f6;transition:background-color .5s,color .5s}.qcu__list-choice input:disabled+label[data-v-af3c8f6a],.qcu__list-choice input[data-v-af3c8f6a]:disabled:hover{cursor:not-allowed}.qcu__list-choice input:disabled:not(:checked)+label[data-v-af3c8f6a],.qcu__list-choice input:disabled:hover:not(:checked)+label[data-v-af3c8f6a]{color:#122647;cursor:not-allowed;opacity:.5;background:#e6f2fe;transition:none}.qcu__list-choice label[data-v-af3c8f6a]{color:inherit;background:#e6f2fe;border-radius:4px;justify-content:center;align-items:center;gap:10px;padding:4px 8px;font-weight:700;transition:background-color .5s,color .5s;display:flex}.qcu .feedback[data-v-af3c8f6a]{background:#e6f2fe;border-radius:8px;flex-direction:column;align-self:stretch;align-items:flex-start;gap:16px;padding:8px 16px;display:flex}"]], ["__scopeId", "data-v-af3c8f6a"]]), U = { class: "complete-phrase" }, W = ["aria-level"], G = { class: "complete-phrase__description" }, K = { class: "complete-phrase__container" }, q = { class: "complete-phrase-container__conversation" }, J = { class: "complete-phrase-container__probabilities" }, Y = ["id", "aria-hidden"], X = /*#__PURE__*/ h(/* @__PURE__ */ _({
	__name: "CompletePhrase.ce",
	props: {
		listOfProbabilityBarsLists: { type: Array },
		userMessage: { type: String },
		llmMessage: { type: String },
		wordsToAdd: { type: Array },
		titleLevel: { type: Number }
	},
	setup(i, { expose: a }) {
		let o = e(0), s = e(null), u = d(() => o.value === i.listOfProbabilityBarsLists.length - 1), h = d(() => i.listOfProbabilityBarsLists[i.listOfProbabilityBarsLists.length - 1]), _ = d(() => {
			let e = i.wordsToAdd[o.value] ?? s.value ?? i.listOfProbabilityBarsLists[o.value][0].name, t = ["complete-message-word"];
			return u.value && t.push(`complete-message-word--${s.value ? "visible" : "hidden"}`), `<p>
  ${i.llmMessage}
  ${i.wordsToAdd.slice(0, o.value).map((e) => `<span class="complete-message-word">${e}</span>`).join(" ")}
  <span class="${t.join(" ")}">${e}</span>
</p>`;
		});
		function v() {
			o.value = 0, s.value = null;
		}
		function y() {
			o.value += 1;
		}
		return a({ reset: v }), (e, a) => (n(), g("div", U, [
			l("div", {
				class: "complete-phrase__title",
				role: "heading",
				"aria-level": i.titleLevel
			}, f(e.$t("complete-phrase.title")), 9, W),
			l("p", G, f(e.$t("complete-phrase.description")), 1),
			l("section", K, [l("div", q, [t(C, {
				class: "container__message",
				message: {
					content: i.userMessage,
					direction: "outbound"
				}
			}, null, 8, ["message"]), t(C, {
				class: "container__message",
				message: {
					content: _.value,
					direction: "inbound"
				}
			}, null, 8, ["message"])]), l("div", J, [(n(!0), g(p, null, r(i.listOfProbabilityBarsLists, (e, t) => (n(), g("div", {
				id: `currentProbability${t}`,
				key: t,
				class: m(["probability", { hidden: t !== o.value }]),
				"aria-hidden": t !== o.value
			}, [(n(!0), g(p, null, r(e, (e, t) => (n(), c(F, {
				key: t,
				name: e.name,
				percent: e.percent
			}, null, 8, ["name", "percent"]))), 128))], 10, Y))), 128))])]),
			u.value ? (n(), c(H, {
				key: 0,
				list: h.value,
				title: e.$t("complete-phrase.successfullyCompletedSentence"),
				onAnswer: a[0] ||= (e) => s.value = e
			}, null, 8, ["list", "title"])) : (n(), c(I, {
				key: 1,
				state: "primary",
				label: e.$t("complete-phrase.clickHereButton"),
				"aria-describedby": `currentProbability${o.value}`,
				onClick: y
			}, null, 8, ["label", "aria-describedby"]))
		]));
	}
}), [["styles", ["*{color:#122647;font-family:Roboto,sans-serif}.complete-phrase__title{text-align:center;font-family:Nunito,sans-serif;font-size:1.75rem;font-weight:700;line-height:36px}.complete-phrase__description{text-align:center;font-size:1rem;font-weight:400;line-height:24px}.complete-phrase__container{grid-template-columns:3fr 2fr;gap:32px;margin-bottom:24px;display:grid}.complete-phrase-container__conversation{background:#fff;border:1px solid #cdd1d9;border-radius:16px;flex-direction:column;gap:32px;padding:1rem;display:flex}.complete-phrase-container__conversation .message{align-items:center}.complete-phrase-container__probabilities{display:grid}.complete-phrase-container__probabilities .probability{flex-direction:column;grid-area:1/1;gap:16px;display:flex}.complete-phrase-container__probabilities .probability.hidden{visibility:hidden}.complete-message-word:last-child{filter:blur(4px);border:none;width:auto;height:auto;font-weight:600}.complete-message-word--visible:last-child{color:inherit;filter:none;font-weight:700}.complete-message-word--hidden:last-child{color:#0000;filter:none;background-color:#f4f5f7;border:1px dashed #5e6c84;border-radius:4px;padding:2px 4px;display:inline-block}.complete-message-word:nth-last-child(2){font-weight:600}@media (width<=600px){.complete-phrase__container{grid-template-columns:1fr}.complete-phrase-container__probabilities .probability.hidden{display:none}}"]]]);
//#endregion
//#region src/webcomponents/complete-phrase/complete-phrase.ce.js
S(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": w,
	"./locales/en.json": T,
	"./locales/es-419.json": E,
	"./locales/es.json": D,
	"./locales/fr-BE.json": O,
	"./locales/fr.json": k,
	"./locales/it.json": A,
	"./locales/nl.json": j
})).catch((e) => console.error(e));
var Z = u(X, { configureApp(e) {
	y.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(b, { i18next: y });
} });
Z.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: v(e.titleLevel)
}), window.customElements.define("complete-phrase", Z);
//#endregion
